import React from 'react';
import Button from '../../../../CommonComponents/BootstrapComponents/Button/Button';
import LKModal from '../../../components/Modal/Modal';
import { deleteExchangeStorageData } from '../../../../utils/helper';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';

export default function PowerFailModal(props) {
  const { CLOSE, RETURN_POWER_FAIL_STATEMENT, PLEASE, CLICK_HERE, TO_UPLOAD_THE_POWERS_AGAIN } =
    props.dataLocale;
  const showPowerFailModal = sessionStorageHelper.getItem('showPowerFailModal');

  const onSubmit = () => {
    deleteExchangeStorageData();
    sessionStorageHelper.setItem('showPowerFailModal', true);
    setTimeout(() => {
      props.history.push({ pathname: `/customer/account/order-detail/${props.orderId}` });
    }, 500);
  };

  if (showPowerFailModal) return '';
  return (
    <LKModal showModal backdrop="static" size="medium">
      <div className="align-items-center display-flex flex-direction-column">
        <div className="margin-b15 fs16">{RETURN_POWER_FAIL_STATEMENT} </div>
        <div className="margin-b15 fs16">
          {PLEASE}{' '}
          <span
            className="cursor-pointer text-lowercase"
            style={{ color: 'blue' }}
            onClick={onSubmit}
          >
            {CLICK_HERE}
          </span>{' '}
          {TO_UPLOAD_THE_POWERS_AGAIN}
        </div>
        <Button
          aria-label="Click to close the Modal"
          className="theme-button"
          onClick={() => {
            sessionStorageHelper.setItem('showPowerFailModal', true);
            props.setShowPowerFailModal(false);
          }}
        >
          <div className="fs16">{CLOSE}</div>
        </Button>
      </div>
    </LKModal>
  );
}
